export const getTranslations = (state) => state.translations || {};
